export default function DbStatsCard({ data, loading }) {
  return (
    <div className={`card bg-base-100 shadow-xl widget-card ${loading ? 'loading' : ''}`} style={{ minHeight: '192px', height: 'auto' }}>
      <div className="card-body py-3 flex flex-col justify-between" style={{ minHeight: '160px' }}>
        <h2 className="card-title text-sm mb-3">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4">
            <path strokeLinecap="round" strokeLinejoin="round" d="M20.25 6.375c0 2.278-3.694 4.125-8.25 4.125S3.75 8.653 3.75 6.375m16.5 0c0-2.278-3.694-4.125-8.25-4.125S3.75 4.097 3.75 6.375m16.5 0v11.25c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125V6.375m16.5 0v3.75m-16.5-3.75v3.75m16.5 0v3.75C20.25 16.153 16.556 18 12 18s-8.25-1.847-8.25-4.125v-3.75m16.5 0c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125" />
          </svg>
          Database Statistics
        </h2>
        
        {loading ? (
          <div className="flex justify-center py-4">
            <span className="loading loading-spinner loading-sm"></span>
          </div>
        ) : data ? (
          <div className="space-y-4">
            <div>
              <div className="text-xs text-gray-500 mb-1">Total Documents</div>
              <div className="flex items-center gap-2">
                <div className="text-xl font-bold text-primary">{data.db_total_docs?.toLocaleString() || 0}</div>
                {data.documents_added_this_search > 0 && (
                  <div className="text-xs bg-success text-success-content px-2 py-1 rounded">
                    +{data.documents_added_this_search}
                  </div>
                )}
              </div>
            </div>
            
            <div>
              <div className="text-xs text-gray-500 mb-1">Relevant Chunks</div>
              <div className="text-xl font-bold text-secondary">{data.related_found || 0}</div>
            </div>
            
            {data.top_sources && data.top_sources.length > 0 && (
              <div>
                <div className="text-xs text-gray-500 mb-1">Top Sources</div>
                <div className="text-xs text-gray-600 truncate" title={data.top_sources.slice(0, 3).join(', ')}>
                  {data.top_sources.slice(0, 3).join(', ')}
                </div>
              </div>
            )}
          </div>
        ) : null}
      </div>
    </div>
  )
}